// Core
import { sessionUtils } from '@openbank/cf-ui-architecture-core';
// Constants
import {
  INTENTIONAL_NAVIGATION,
  INTENTIONAL_NAVIGATION_ON,
} from 'components/header-layout/constants/header-layout.constants';
// Resolvers
import { errorLogResolver } from '../resolvers/error.resolver';
import { expireCurrentOrderResolver } from 'resolvers/expire-order.resolver';
// Types
import {
  ErrorHandlersType,
  ErrorMethodsHandlersType,
  ExpireCurrentOnboardingAndRedirectToAmazonHandlerType,
  ManageErrorButtonClickHandlerType,
  SendErrorLogHandlerType,
} from './types/error.handlers.type';
// Utilities
import { navigateToCallbackUrl } from 'utils/app-callback-url.utils';
import { shouldReloadPage } from './utils/error.handlers.utils';
import { isDeclinedOnboardingError } from '../utils/error.utils';

const expireCurrentOnboardingAndRedirectToAmazonHandler = async ({
  clearAllSessionIntervalsProcesses,
  ...props
}: ExpireCurrentOnboardingAndRedirectToAmazonHandlerType): Promise<void> => {
  await expireCurrentOrderResolver();
  clearAllSessionIntervalsProcesses();
  sessionUtils.clearSessionData();
  navigateToCallbackUrl(props);
};

const manageErrorButtonClickHandler = ({
  clearAllSessionIntervalsProcesses,
  mappedError,
  ...props
}: ManageErrorButtonClickHandlerType): void => {
  switch (true) {
    case shouldReloadPage(mappedError):
      localStorage.setItem(INTENTIONAL_NAVIGATION, INTENTIONAL_NAVIGATION_ON);
      window.location.reload();
      break;
    case isDeclinedOnboardingError(mappedError):
      expireCurrentOnboardingAndRedirectToAmazonHandler({
        clearAllSessionIntervalsProcesses,
        ...props,
      });
      break;
    default:
      navigateToCallbackUrl(props);
      break;
  }
};

const closeCancelApplicationModalHandler = ({
  setShowModal,
}: Pick<ErrorMethodsHandlersType, 'setShowModal'>): void => {
  setShowModal(false);
};

const showCancelApplicationModalHandler = ({
  setShowModal,
}: Pick<ErrorMethodsHandlersType, 'setShowModal'>): void => {
  setShowModal(true);
};

const sendErrorLogHandler = async ({
  loanId,
  mappedError,
}: SendErrorLogHandlerType): Promise<void> => {
  if (loanId) {
    await errorLogResolver({ error: mappedError });
  }
};

const ErrorHandlers = ({
  callbackUrl,
  clearAllSessionIntervalsProcesses,
  loanId,
  mappedError,
  setShowModal,
}: ErrorMethodsHandlersType): ErrorHandlersType => ({
  handleCloseCancelApplicationModal: () => closeCancelApplicationModalHandler({ setShowModal }),
  handleManageErrorButtonClick: () =>
    manageErrorButtonClickHandler({
      loanId,
      callbackUrl,
      clearAllSessionIntervalsProcesses,
      mappedError,
    }),
  handleSendErrorLog: () => sendErrorLogHandler({ loanId, mappedError }),
  handleShowCancelApplicationModal: () => showCancelApplicationModalHandler({ setShowModal }),
});

export { ErrorHandlers };
